import * as React from "react"

function InvoiceIcon({...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0  15.641 17"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={-0.133}
          y1={0.279}
          x2={1.133}
          y2={0.721}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
      </defs>
      <g data-name="Group 112">
        <g data-name="Group 29">
          <path
            data-name="Path 29"
            d="M13.9 0h-.434a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 0110.861 0H9.124a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 016.517 0H4.779a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 012.172 0h-.434A1.6 1.6 0 000 1.417v14.166A1.6 1.6 0 001.738 17h.434a1.2 1.2 0 011.3-1.062A1.2 1.2 0 014.779 17h1.738a1.2 1.2 0 011.3-1.062A1.2 1.2 0 019.124 17h1.738a1.2 1.2 0 011.3-1.062A1.2 1.2 0 0113.468 17h.432a1.6 1.6 0 001.738-1.417V1.417A1.6 1.6 0 0013.9 0z"
            fill="#e6e6e5"
          />
          <path
            data-name="Path 30"
            d="M13.9 0h-.434a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 0110.861 0H9.124a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 016.517 0H4.779a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 012.172 0h-.434A1.6 1.6 0 000 1.417v.177A1.6 1.6 0 011.738.177h.434a1.2 1.2 0 001.3 1.062A1.2 1.2 0 004.779.177h1.738a1.2 1.2 0 001.3 1.062 1.2 1.2 0 001.3-1.062h1.738a1.2 1.2 0 001.3 1.062 1.2 1.2 0 001.3-1.062h.445a1.6 1.6 0 011.738 1.417v-.177A1.6 1.6 0 0013.9 0z"
            fill="#fff"
            opacity={0.2}
          />
          <path
            data-name="Path 31"
            d="M1.738 17h.434a1.2 1.2 0 011.3-1.062 1.2 1.2 0 011.3 1.063h1.745a1.2 1.2 0 011.3-1.062 1.2 1.2 0 011.3 1.063h1.738a1.2 1.2 0 011.3-1.062 1.2 1.2 0 011.3 1.063h.445a1.6 1.6 0 001.738-1.417v-.18a1.6 1.6 0 01-1.738 1.417h-.434a1.2 1.2 0 00-1.3-1.062 1.2 1.2 0 00-1.3 1.062H9.124a1.2 1.2 0 00-1.3-1.062 1.2 1.2 0 00-1.3 1.062H4.779a1.2 1.2 0 00-1.3-1.062 1.2 1.2 0 00-1.3 1.062h-.441A1.6 1.6 0 010 15.406v.177A1.6 1.6 0 001.738 17z"
            fill="#010101"
            opacity={0.1}
          />
          <path
            data-name="Path 32"
            d="M2.125 5.667h11.391v.708H2.125zm0-2.125h11.391v.708H2.125zm0 6.375h6.644v.708H2.125zm0-2.125h11.391V8.5H2.125zm0 4.25h6.644v.708H2.125zm10.441-2.479h-.949v.419a1.136 1.136 0 00-.949 1c0 .586.639 1.062 1.424 1.062.262 0 .475.159.475.354s-.212.354-.475.354h-1.424v.708h.949v.354h.949v-.419a1.136 1.136 0 00.949-1c0-.586-.639-1.062-1.424-1.062-.262 0-.475-.159-.475-.354s.212-.354.475-.354h1.424v-.708h-.949z"
            fill="#2d98d4"
          />
          <path
            data-name="Path 33"
            d="M16.9 0h-.434a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 0113.861 0h-1.737a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 019.517 0H7.779a1.2 1.2 0 01-1.3 1.062A1.2 1.2 0 015.172 0h-.434A1.6 1.6 0 003 1.417v14.166A1.6 1.6 0 004.738 17h.434a1.2 1.2 0 011.3-1.062A1.2 1.2 0 017.779 17h1.738a1.2 1.2 0 011.3-1.062A1.2 1.2 0 0112.124 17h1.738a1.2 1.2 0 011.3-1.062A1.2 1.2 0 0116.468 17h.432a1.6 1.6 0 001.738-1.417V1.417A1.6 1.6 0 0016.9 0z"
            transform="translate(-3)"
            fill="url(#prefix__a)"
          />
        </g>
      </g>
    </svg>
  )
}

export default InvoiceIcon
